var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-panel"},[_c('div',{staticClass:"fa fa-print",attrs:{"title":"Drukuj dokumentację"},on:{"click":_vm.prepareDocsPrint}}),_c('div',{staticClass:"fa fa-file-pdf-o",attrs:{"title":"Pobierz dokumentację PDF"},on:{"click":_vm.getPdfFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }